import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [pw, setPw] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            const u = await login(email, pw);
            toast.success("Welcome back");
            nav(u.role === "admin" ? "/admin" : "/account");
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        }
        setBusy(false);
    };

    return (
        <div className="min-h-[70vh] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="eyebrow">Welcome</div>
                    <h1 className="font-serif-luxe text-4xl mt-2">Sign In</h1>
                </div>
                <form onSubmit={submit} className="space-y-4 card-luxe p-8" data-testid="login-form">
                    <div>
                        <label className="text-xs tracking-[0.15em] uppercase text-[color:var(--muted-brown)]">Email</label>
                        <input data-testid="login-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full border border-[color:var(--soft-border)] focus:border-[color:var(--champagne)] outline-none px-3 py-2.5 mt-1 bg-transparent" />
                    </div>
                    <div>
                        <label className="text-xs tracking-[0.15em] uppercase text-[color:var(--muted-brown)]">Password</label>
                        <input data-testid="login-password" type="password" required value={pw} onChange={e => setPw(e.target.value)} className="w-full border border-[color:var(--soft-border)] focus:border-[color:var(--champagne)] outline-none px-3 py-2.5 mt-1 bg-transparent" />
                    </div>
                    {err && <div className="text-xs text-[color:var(--destructive)]">{err}</div>}
                    <button disabled={busy} data-testid="login-submit" className="btn-primary w-full">{busy ? "Signing in…" : "Sign In"}</button>
                    <div className="text-xs text-center text-[color:var(--muted-brown)]">New to Singh Jewellers? <Link to="/register" className="text-[color:var(--champagne)] link-underline">Create Account</Link></div>
                </form>
            </div>
        </div>
    );
}

export function Register() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const upd = k => e => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            await register(form);
            toast.success("Account created");
            nav("/account");
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        }
        setBusy(false);
    };
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="eyebrow">Join the Family</div>
                    <h1 className="font-serif-luxe text-4xl mt-2">Create Account</h1>
                </div>
                <form onSubmit={submit} className="space-y-4 card-luxe p-8" data-testid="register-form">
                    {["name", "email", "phone", "password"].map(k => (
                        <div key={k}>
                            <label className="text-xs tracking-[0.15em] uppercase text-[color:var(--muted-brown)]">{k}</label>
                            <input data-testid={`reg-${k}`} type={k === "password" ? "password" : k === "email" ? "email" : "text"} required={k !== "phone"} value={form[k]} onChange={upd(k)} className="w-full border border-[color:var(--soft-border)] focus:border-[color:var(--champagne)] outline-none px-3 py-2.5 mt-1 bg-transparent" />
                        </div>
                    ))}
                    {err && <div className="text-xs text-[color:var(--destructive)]">{err}</div>}
                    <button disabled={busy} data-testid="register-submit" className="btn-primary w-full">{busy ? "Creating…" : "Create Account"}</button>
                    <div className="text-xs text-center text-[color:var(--muted-brown)]">Have an account? <Link to="/login" className="text-[color:var(--champagne)] link-underline">Sign In</Link></div>
                </form>
            </div>
        </div>
    );
}
